import { Component, OnInit } from '@angular/core';
import {ConfiguracaoEmail} from "../models/configuracao-email";
import {ComunicacaoService} from "../services/comunicacao.service";
import {Email} from "../models/email";
import {Comunicacao} from "../models/comunicacao";

interface Contact {
  id: number;
  name: string;
  email: string;
  avatar?: string;
}

@Component({
  selector: 'app-email',
  standalone: false,
  templateUrl: './email.component.html',
  styleUrl: './email.component.css'
})
export class EmailComponent implements OnInit {
  listaConfiguracoes: ConfiguracaoEmail[] = [];
  // Mapa de emails por configuração
  emailsPorConfig: { [configId: number]: Email } = {};
  categoriaAtual: string = 'inbox';
  configIdAtual: number;
  selectedEmail: Comunicacao | null = null;
  selectedFolder: string | null = null;

  constructor(private comunicacaoService: ComunicacaoService) {
  }

  ngOnInit(): void {
    this.listarConfigs();
  }

  listarConfigs(){
    // Buscar TODAS as configurações ao abrir a tela
    this.comunicacaoService.selecionarListaConfiguracoes().subscribe(resultado => {
      if(resultado.sucesso){
        this.listaConfiguracoes = resultado.dados;

        if (this.listaConfiguracoes.length > 0) {
          // Definir configuração e pasta padrão
          this.configIdAtual = this.listaConfiguracoes[0].id;
          this.selectedFolder = 'inbox';
          this.categoriaAtual = 'inbox';

          // Pré-carregar emails para todas as configurações
          this.listaConfiguracoes.forEach(cfg => this.preCarregarEmails(cfg.id));
        }
      }
    })
  }

  private preCarregarEmails(configId: number){
    this.comunicacaoService.selecionarEmailsPorConfigPorOrigemPorUsuario(configId).subscribe(resultado => {
      if(resultado.sucesso){
        this.emailsPorConfig[configId] = resultado.dados as Email;
      }
    })
  }

  listarEmailPorConfig(configId: number, categoria: string = 'inbox'){
    this.configIdAtual = configId;
    this.categoriaAtual = categoria;
    this.selectedFolder = categoria;
    this.selectedEmail = null;

    // Se ainda não carregou para esta config, buscar agora
    if (!this.emailsPorConfig[configId]) {
      this.preCarregarEmails(configId);
    }
  }

  selectEmail(email: Comunicacao) {
    this.selectedEmail = email;

    // Marcar como lido se estiver na caixa de entrada
    if (!email.lido && this.categoriaAtual === 'inbox') {
      email.lido = true;
      // Aqui normalmente chamaria o service para persistir a alteração
      // this.comunicacaoService.markAsRead(email.id).subscribe(...)
    }
  }

  getEmailsByFolder(tipo: string): Comunicacao[] {
    const dados = this.emailsPorConfig[this.configIdAtual];
    if (!dados) return [];

    switch(tipo) {
      case 'inbox':
        return [...(dados.emailsNaoLidos ?? []), ...(dados.emailsLidos ?? [])];
      case 'sent':
        return [...(dados.emailsEnviados ?? [])];
      case 'drafts':
        return [...(dados.rascunhos ?? [])];
      default:
        return [];
    }
  }

  contarPorPasta(configId: number, pasta: 'inbox' | 'sent' | 'drafts'): number {
    const dados = this.emailsPorConfig[configId];
    if (!dados) return 0;
    switch (pasta) {
      case 'inbox':
        return (dados.emailsNaoLidos?.length ?? 0) + (dados.emailsLidos?.length ?? 0);
      case 'sent':
        return dados.emailsEnviados?.length ?? 0;
      case 'drafts':
        return dados.rascunhos?.length ?? 0;
    }
  }

  buscarNome(email: string): string {
    const contato = this.listaConfiguracoes.find(c => c.email === email);
    return contato ? (contato.display || contato.email) : email;
  }

  buscarIniciais(nome: string) {
    if (!nome) return '';
    const palavras = nome.trim().split(" ");
    const iniciais = palavras.map(palavra => palavra.charAt(0).toUpperCase());
    return iniciais.join("");
  }
}
